import { flowRight as compose } from 'lodash';

import dataView from '~lib/common/hoc/dataView';
import renameProps from '~lib/common/hoc/renameProps';

import CaseEnvironment from './CaseEnvironment.vue';
import queries from '~lib/common/queries/Environment';

const enhance = compose(dataView({ queries }), renameProps({ data: 'environments' }));

export default enhance(CaseEnvironment);
